import {Component} from '@angular/core';
import {NavParams, ViewController} from 'ionic-angular';

/**
 * Generated class for the ModalNavPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-modal-nav',
  templateUrl: 'modal-nav.html',
})
export class ModalNavPage {

  public modalPage: any;
  public modalParams: any = {};

  constructor(public viewCtrl: ViewController, public navParams: NavParams) {
    this.modalParams = navParams.get('param');
    this.modalPage = navParams.get('page');
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ModalNavPage');
  }

  dismissModal(data?) {
    this.viewCtrl.dismiss(data);
  }

}



// WEBPACK FOOTER //
// ./src/pages/modal-nav/modal-nav.ts